import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=8b5a6568&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=ts&"
export * from "./BaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=8b5a6568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5a6568",
  null
  
)

export default component.exports